import { IncomingMessage } from 'http';

import { QueryFunction, QueryKey } from '@tanstack/react-query';

import fetchUniqueVehicle from '../../../services/vehicles/unique-vehicle';

const getUniqueVehicle = (
  options: {
    locale: string;
    vehicle: string;
    detailed_prices?: boolean;
    is_advanced_view?: boolean;
  },
  req?: IncomingMessage
): [QueryKey, QueryFunction<ReturnType<typeof fetchUniqueVehicle>>] => [
  ['user-dependent', 'unique-vehicle', options],
  ({
    queryKey: [, , key],
  }: {
    queryKey: [
      string,
      string,
      {
        locale: string;
        vehicle: string;
        detailed_prices: boolean;
        is_advanced_view: boolean;
      }
    ];
  }) => fetchUniqueVehicle(key, req),
];

export default getUniqueVehicle;
